/* PDP icon replacement: swaps emoji for SVGs or uploaded images.
   Reads overrides from #pdp-icon-cfg (rendered by sections/pdp-icon-config).
   Falls back to built-in stroke SVGs when no override is uploaded. */
(function(){
  var cfg = document.getElementById('pdp-icon-cfg');
  function img(key, cls) {
    var url = cfg && cfg.dataset[key];
    if (url) return '<img src="' + url + '" class="' + cls + '" alt="">';
    return null;
  }

  var D = {
    truck: img('truck','pdp-li-icon') || '<svg class="pdp-li-icon" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    chat: img('chat','pdp-li-icon') || '<svg class="pdp-li-icon" viewBox="0 0 24 24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>',
    pkg: img('pkg','pdp-li-icon') || '<svg class="pdp-li-icon" viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
    zap: img('zap','pdp-li-icon') || '<svg class="pdp-li-icon" viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    check: img('check','pdp-li-icon') || '<svg class="pdp-li-icon" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
    pin: img('pin','pdp-li-icon') || '<svg class="pdp-li-icon" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    warn: img('warn','pdp-li-icon') || '<svg class="pdp-li-icon" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
    chatLg: img('chatlg','pdp-lg-icon') || '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--purple)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>'
  };

  /* Decorative overrides: use uploaded image or strip to empty */
  var deco = {
    placeholder: img('placeholder','pdp-deco-icon') || '',
    vintage: img('vintage','pdp-deco-icon') || '',
    firsted: img('firsted','pdp-deco-icon') || '',
    shadowless: img('shadowless','pdp-deco-icon') || '',
    ability: img('ability','pdp-deco-icon') || '',
    holo: img('holo','pdp-deco-icon') || ''
  };

  var rules = [
    [/\u{1F4EC}\s?/u, 'truck'],
    [/\u{1F4E6}\s?/u, 'pkg'],
    [/\u{1F680}\s?/u, 'zap'],
    [/\u2705\s?/u, 'check'],
    [/\u{1F4CD}\s?/u, 'pin'],
    [/\u26A0\uFE0F?\s?/u, 'warn'],
    [/\u{1F4AC}/u, 'chat']
  ];

  function fix(scope) {
    scope.querySelectorAll('li').forEach(function(li) {
      rules.forEach(function(r) {
        if (r[0].test(li.innerHTML)) {
          li.innerHTML = li.innerHTML.replace(r[0], D[r[1]] + ' ');
        }
      });
    });
  }

  var usps = document.querySelector('.pdp-usps');
  if (usps) fix(usps);
  var ship = document.querySelector('.pdp-ship-list');
  if (ship) fix(ship);

  var modal = document.getElementById('pdp-modal');
  if (modal) {
    var p = modal.querySelector('.pdp-modal__box > p:first-child');
    if (p && /\u{1F4AC}/u.test(p.textContent)) {
      p.innerHTML = D.chatLg;
      p.style.fontSize = '';
    }
  }

  /* Decorative emoji: replace with uploaded image or strip */
  var decoMap = [
    ['.pdp-card-placeholder', /\u{1F0CF}/gu, deco.placeholder],
    ['.pdp-acc--vintage .pdp-acc__hd span', /\u{1F3C6}\s?/gu, deco.vintage],
    ['.pdp-vintage-flag__icon', /\u2B50/gu, deco.firsted],
    ['.pdp-vintage-flag__icon', /\u{1F31E}/gu, deco.shadowless],
    ['.pdp-gp--ability .pdp-gp__label', /\u26A1\s?/gu, deco.ability],
    ['.pdp-pill--holo', /\u2728\s?/gu, deco.holo]
  ];
  decoMap.forEach(function(d) {
    document.querySelectorAll(d[0]).forEach(function(el) {
      if (d[1].test(el.textContent)) {
        d[1].lastIndex = 0;
        el.innerHTML = el.innerHTML.replace(d[1], d[2]);
      }
    });
  });

  if (!document.querySelector('style[data-pdp-icons]')) {
    var st = document.createElement('style');
    st.setAttribute('data-pdp-icons', '1');
    st.textContent = '.pdp-li-icon{width:16px;height:16px;flex-shrink:0;vertical-align:-3px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;color:var(--purple);display:inline}.pdp-lg-icon{width:32px;height:32px;display:block}.pdp-deco-icon{width:20px;height:20px;vertical-align:-3px;display:inline}';
    document.head.appendChild(st);
  }
})();
